import { Grid } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useState } from 'react';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { demergeCandidate, demergeCandidateById } from 'wisestep-api';
import {
  ControlledTextInput,
  Item,
  WsButton,
  WsColors,
  WsListingLoader,
  WsTitleBanner,
} from 'wisestep-base';

import { success, warning } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

const DemergeCandidates = () => {
  const methods = useForm();
  const { handleSubmit } = methods;
  const navigate = useNavigate();
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: FieldValues) => {
    try {
      setIsLoading(true);
      isEmpty(data.emailid)
        ? await demergeCandidateById(data.candidateid)
        : await demergeCandidate(data.candidateid, data.emailid);

      setIsLoading(false);
      setNotification(success('Your action is Successfully completed'));
    } catch (error) {
      setIsLoading(false);
      setNotification(warning('Something went wrong, Please try again.'));
    }
  };

  return (
    <Grid container>
      <Grid xs={12} pb={2}>
        <WsTitleBanner title={'Demerge Candidates'} goBack={() => navigate('/')} />
      </Grid>
      {!isLoading ? (
        <>
          <Grid item container ml={0} bgcolor={WsColors.White} p={4} spacing={2} gap={4}>
            <Grid item xs={6} marginTop={2} pl={0} borderRadius={1.5}>
              <FormProvider {...methods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Item>
                    <Grid spacing={1} direction="column">
                      <ControlledTextInput
                        name="candidateid"
                        labelText="Enter Candidate Id *"
                        type="text"
                        fullWidth
                        id="candidateid"
                        placeholder="Enter Candidate Id"
                        variant="outlined"
                        required
                        autoComplete="candidateid"
                      />
                    </Grid>
                    <Grid mt={1} spacing={1} direction="column">
                      <ControlledTextInput
                        name="emailid"
                        labelText="Email Id"
                        type="email"
                        fullWidth
                        id="emailid"
                        placeholder="Eg, johndoe@email.com"
                        variant="outlined"
                        autoComplete="email"
                      />
                    </Grid>
                    <Grid mt={3} spacing={1} direction="column" justifyContent="flex-end">
                      <WsButton variant="contained" size="medium" type="submit">
                        Demerge
                      </WsButton>
                    </Grid>
                  </Item>
                </form>
              </FormProvider>
            </Grid>
          </Grid>
        </>
      ) : (
        <Grid item xs={12}>
          <WsListingLoader />
        </Grid>
      )}
    </Grid>
  );
};

export default DemergeCandidates;
